import PropTypes from 'prop-types';
import React from 'react';
import humanize from 'underscore.string/humanize';

import AffiliateTime from '../../components/Filters/AffiliateTime';
import GenericFormItem from '../GenericFormItem';

const TimeWindow = function TimeWindow(props) {
  const {
    val,
    label,
  } = props;
  let value = null;
  if (val === 'immediate') {
    value = (
      <h4 className="uk-margin-small-bottom">
        {humanize(val)}
      </h4>
    );
  } else {
    value = (
      <h4 className="uk-margin-small-bottom">
        <AffiliateTime time={val} mask="hh:mm A MM/DD/YY" />
      </h4>
    );
  }

  return (
    <GenericFormItem label={label}>
      {value}
    </GenericFormItem>
  );
};

TimeWindow.propTypes = {
  val: PropTypes.string,
  label: PropTypes.string,
};

export default TimeWindow;



// WEBPACK FOOTER //
// ./src/components/FormConfigs/TimeWindow.js